import * as config from '../../constants';
import "isomorphic-fetch";
import axios from 'axios';



export function getCurrentUserData() {
    const requestOptions =
    {
        method: 'POST',
        headers: { "Content-Type": 'application/json' },
        withCredentials: true
    }
    return axios({ url: `${config.apiUrl}/auth/user`, ...requestOptions })
}

export function resetPassword(data) {
    const requestOptions =
    {
        method: 'POST',
        headers: { "Content-Type": 'application/json' },
        withCredentials: true,
        data:JSON.stringify(data)
    }
    return axios({ url: `${config.apiUrl}/auth/resetPassword`, ...requestOptions })
}

export function changePassword(data) {
    const requestOptions =
    {
        method: 'POST',
        headers: { "Content-Type": 'application/json' },
        withCredentials: true,
        data:JSON.stringify(data)
    }
    return axios({ url: `${config.apiUrl}/auth/changePassword`, ...requestOptions })
}